import { NavLink, useNavigate } from 'react-router-dom'

// components
export default function MoreOptions() {
    const navigate = useNavigate();
    return (
        <div className="home-center-content1 home-center-content3">
            <div className="titleBlock icon">
                <div className="iconWrapper" onClick={ () => navigate('/queuing/tickets/')}><ion-icon name="arrow-back-outline"></ion-icon></div>
                <h5>More Options</h5>
                <h5>Back</h5>
            </div>
            <NavLink to='/'>Call ticket by number</NavLink>
            <NavLink to='/'>Re-Queue ticket</NavLink>
        </div>
    )
}
